module.exports = __webpack_public_path__ + "img/413.c4b27ee3.png";